
import { defineComponent } from "vue";
import CommonInput from "@/views/shared/form-parts/CommonInput.vue";
import { useGlobalStore } from "@/stores/global";

export default defineComponent({
  name: "CouponCodes",
  components: {
    CommonInput,
  },
  computed: {
    defaultCampaignCode(): string {
      return useGlobalStore().couponCodes.campCode;
    },
    defaultAgencyCode(): string {
      return useGlobalStore().couponCodes.agencyCode;
    },
    isSetCode(): boolean {
      return !!this.defaultCampaignCode || !!this.defaultAgencyCode;
    },
  },
  created() {
    if (this.defaultCampaignCode) {
      this.$emit("update:campaignCode", this.defaultCampaignCode);
    }
    if (this.defaultAgencyCode) {
      this.$emit("update:agencyCode", this.defaultAgencyCode);
    }
  },
  props: {
    campaignCode: {
      type: String,
      required: true,
    },
    agencyCode: {
      type: String,
      required: true,
    },
  },
  methods: {
    onInputCampaignCode(event: Event): void {
      if (!(event.target instanceof HTMLInputElement)) return;
      this.$emit("update:campaignCode", event.target.value);
    },
    onInputAgencyCode(event: Event): void {
      if (!(event.target instanceof HTMLInputElement)) return;
      this.$emit("update:agencyCode", event.target.value);
    },
  },
  emits: ["update:campaignCode", "update:agencyCode"],
});
